import Alert from './Alert';
import Tick from './Tick';

export { Alert, Tick };
